"use client";

import { useEffect } from "react";
import { CheckCircle2, Sparkles, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WHATSAPP_CONFIG } from "@/config/constants";

export default function Obrigado() {
  useEffect(() => {
    // Scroll to top quando a página carregar
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="relative min-h-screen w-full overflow-hidden flex items-center justify-center px-4">
      {/* Background animado */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-primary">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary/30 rounded-full blur-[100px] motion-safe:animate-glow-pulse" aria-hidden />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent/20 rounded-full blur-[100px] motion-safe:animate-glow-pulse" style={{ animationDelay: "2s" }} aria-hidden />
      </div>

      {/* Grid background */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.03] [mask-image:radial-gradient(70%_70%_at_50%_50%,black,transparent)]"
        style={{
          backgroundImage:
            "linear-gradient(to right, hsl(var(--border)) 1px, transparent 1px), linear-gradient(to bottom, hsl(var(--border)) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      {/* Conteúdo */}
      <div className="relative z-10 w-full max-w-3xl">
        <div className="text-center space-y-8 motion-safe:animate-fade-in">
          {/* Ícone de sucesso */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-green-500/20 rounded-full blur-2xl animate-pulse" />
              <div className="relative bg-gradient-to-br from-green-400 to-emerald-500 rounded-full p-6">
                <CheckCircle2 className="w-16 h-16 text-white" />
              </div>
            </div>
          </div>

          {/* Título Principal */}
          <div className="space-y-4">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-black leading-tight">
              Obrigado pela sua
              <span className="bg-gradient-accent bg-clip-text text-transparent drop-shadow-[0_0_18px_rgba(100,192,242,0.6)]">
                {" "}escolha!
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              Você deu o primeiro passo para uma transformação real. 
              Estamos aqui para te ajudar nessa jornada.
            </p>
          </div>

          {/* Card de próximos passos */}
          <div className="bg-gradient-to-br from-primary/10 to-accent/5 border border-primary/30 rounded-2xl p-8 md:p-10 space-y-6 text-left max-w-2xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <Sparkles className="w-6 h-6 text-accent" />
              <h2 className="text-2xl font-bold">Próximos passos:</h2>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center mt-1">
                  <span className="text-accent font-bold">1</span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Verifique seu email</h3>
                  <p className="text-muted-foreground">
                    Enviamos todas as informações de acesso para o email cadastrado. 
                    Confira também a caixa de spam.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center mt-1">
                  <span className="text-accent font-bold">2</span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Entre no grupo de suporte</h3>
                  <p className="text-muted-foreground">
                    Junte-se à nossa comunidade exclusiva no WhatsApp para receber 
                    suporte, dicas e se conectar com outras pessoas na mesma jornada.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center mt-1">
                  <span className="text-accent font-bold">3</span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">Comece agora</h3>
                  <p className="text-muted-foreground">
                    Não espere! Quanto antes você começar, mais rápido verá os resultados. 
                    O momento é agora.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTAs */}
          <div className="flex justify-center pt-4">
            <Button
              variant="hero"
              size="xl"
              onClick={() => window.location.href = WHATSAPP_CONFIG.supportLink}
              className="group"
            >
              Falar com Suporte
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          {/* Mensagem final */}
          <div className="pt-8 border-t border-white/10">
            <p className="text-muted-foreground">
              Precisa de ajuda?{" "}
              <a 
                href={WHATSAPP_CONFIG.supportLink} 
                className="text-accent hover:underline font-semibold"
              >
                Entre em contato conosco
              </a>
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}
